import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const STORAGE_KEY = 'cookie-consent';

const StyledBanner = styled.div`
  position: fixed;
  left: 50%;
  bottom: calc(20px + env(safe-area-inset-bottom, 0px));
  transform: translateX(-50%);
  z-index: 100;
  display: flex;
  align-items: center;
  gap: 20px;
  width: calc(100% - 32px);
  max-width: 640px;
  padding: 16px 20px;
  color: var(--light-slate);
  background-color: var(--light-navy);
  border: 1px solid var(--dark-slate);
  border-radius: var(--border-radius);
  box-shadow: 0 10px 30px -10px var(--navy-shadow);
  font-size: var(--fz-xs);
  line-height: 1.5;

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: stretch;
    gap: 14px;
  }

  p {
    flex: 1;
    margin: 0;
  }

  .actions {
    display: flex;
    flex-shrink: 0;
    gap: 10px;
  }

  button {
    ${({ theme }) => theme.mixins.smallButton};
    flex: 1;
    white-space: nowrap;
    font-size: var(--fz-xs);
  }

  button.reject {
    color: var(--light-slate);
    border-color: var(--dark-slate);

    &:hover,
    &:focus-visible {
      color: var(--white);
      background-color: transparent;
      border-color: var(--light-slate);
    }
  }
`;

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) {
        setVisible(true);
      }
    } catch (e) {
      setVisible(true);
    }
  }, []);

  const choose = granted => {
    const value = granted ? 'granted' : 'denied';
    try {
      localStorage.setItem(STORAGE_KEY, value);
    } catch (e) {
      // sin almacenamiento: la elección solo vale para esta página
    }
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('consent', 'update', { analytics_storage: value });
    }
    setVisible(false);
  };

  if (!visible) {
    return null;
  }

  return (
    <StyledBanner role="dialog" aria-label="Aviso de cookies">
      <p>
        Uso cookies de Google Analytics solo para medir visitas de forma anónima y mejorar la web.
        ¿Las aceptas?
      </p>
      <div className="actions">
        <button type="button" className="reject" onClick={() => choose(false)}>
          Rechazar
        </button>
        <button type="button" onClick={() => choose(true)}>
          Aceptar
        </button>
      </div>
    </StyledBanner>
  );
};

export default CookieBanner;
